import { Trans, useTranslation } from 'react-i18next';
import classes from './Conditioning.module.scss';
import icon_01 from '../../../assets/img/Plumbing/Conditioning/icon_01.svg';
import icon_02 from '../../../assets/img/Plumbing/Conditioning/icon_02.svg';
import icon_03 from '../../../assets/img/Plumbing/Conditioning/icon_03.svg';
import icon_04 from '../../../assets/img/Plumbing/Conditioning/icon_04.svg';
import icon_05 from '../../../assets/img/Plumbing/Conditioning/icon_05.svg';
import { useState } from 'react';

const tabs = [
    {
        icon: icon_01,
        subtitle: 'plumbing.conditioning.tab_01.subtitle',
        text: 'plumbing.conditioning.tab_01.text',
        desc: 'plumbing.conditioning.tab_01.desc',
    },
    {
        icon: icon_02,
        subtitle: 'plumbing.conditioning.tab_02.subtitle',
        text: 'plumbing.conditioning.tab_02.text',
        desc: 'plumbing.conditioning.tab_02.desc',
    },
    {
        icon: icon_03,
        subtitle: 'plumbing.conditioning.tab_03.subtitle',
        text: 'plumbing.conditioning.tab_03.text',
        desc: 'plumbing.conditioning.tab_03.desc',
    },
    {
        icon: icon_04,
        subtitle: 'plumbing.conditioning.tab_04.subtitle',
        text: 'plumbing.conditioning.tab_04.text',
        desc: 'plumbing.conditioning.tab_04.desc',
    },
    {
        icon: icon_05,
        subtitle: 'plumbing.conditioning.tab_05.subtitle',
        text: 'plumbing.conditioning.tab_05.text',
        desc: 'plumbing.conditioning.tab_05.desc',
    },
];

const Conditioning = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);

    const setTab = (index) => setActive(index === active ? -1 : index);

    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={`${classes.tabs} ${classes.tabs_01}`}>
                    {tabs.slice(0, 3).map((tab, index) =>
                        <div
                            key={index}
                            onClick={() => setTab(index)}
                            className={`${classes.tab} ${active === index ? classes.active : ''} no-select`}
                        >
                            <div className={classes.head}>
                                <img className={classes.icon} src={tab.icon} alt='' />
                                <div>
                                    <h4 className={`${classes.subtitle} font-20`}>
                                        {t(tab.subtitle)}
                                    </h4>
                                    <p className={`${classes.text} font-16`}>
                                        {t(tab.text)}
                                    </p>
                                </div>
                                <div className={classes.status}></div>
                            </div>
                            <p className={`${classes.desc} font-16`}>
                                <Trans>
                                    {t(tab.desc)}
                                </Trans>
                            </p>
                        </div>
                    )}
                </div>
                <div className={classes.tabs}>
                    {tabs.slice(3, 6).map((tab, index) =>
                        <div
                            key={index}
                            onClick={() => setTab(index + 3)}
                            className={`${classes.tab} ${active === index + 3 ? classes.active : ''} no-select`}
                        >
                            <div className={classes.head}>
                                <img className={classes.icon} src={tab.icon} alt='' />
                                <div>
                                    <h4 className={`${classes.subtitle} font-20`}>
                                        {t(tab.subtitle)}
                                    </h4>
                                    <p className={`${classes.text} font-16`}>
                                        {t(tab.text)}
                                    </p>
                                </div>
                                <div className={classes.status}></div>
                            </div>
                            <p className={`${classes.desc} font-16`}>
                                <Trans>
                                    {t(tab.desc)}
                                </Trans>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Conditioning;
